import { GamePhase } from '../entities/GamePhase';
import { InterfaceView } from '../entities/InterfaceView';
import { ChangeGamePhaseEvent } from '../events/changeGamePhase/ChangeGamePhaseEvent';
import { NavigateEvent } from '../events/navigateEvent/NavigateEvent';
import { VideoExtractStartEvent } from '../events/videoExtractStart/VideoExtractStartEvent';
import { UseCase } from './UseCase';
export class NewCleavageUseCase extends UseCase {
    constructor(applicationServices) {
        super();
        this.applicationServices = applicationServices;
    }
    execute(event) {
        return this.applicationServices.chat.isConnected()
            .then(isConnected => isConnected
            ? this.onConnected()
            : this.applicationServices.event.sentEvent(new NavigateEvent(InterfaceView.CONNECT_CHAT)))
            .catch(error => Promise.reject(error));
    }
    onConnected() {
        return this.applicationServices.interface.newCleavage()
            .then(() => Promise.all([
            this.applicationServices.interface.retrieveCurrentView(),
            this.applicationServices.cleavage.retrieveCurrentGamePhase()
        ]))
            .then(([currentView, currentGamePhase]) => this.applicationServices.event.sentEvents([
            ...currentGamePhase === GamePhase.NEW_CLEAVAGE ? [] : currentView !== InterfaceView.GAME ? [new ChangeGamePhaseEvent(GamePhase.NEW_CLEAVAGE)] : [new VideoExtractStartEvent({ fullRandom: true })],
            ...currentView !== InterfaceView.GAME ? [new NavigateEvent(InterfaceView.GAME)] : []
        ]))
            .catch(error => Promise.reject(error));
    }
}
